import { CelebrationEvent } from '../interfaces/celebration-event.interface';

export const Celebration: CelebrationEvent[] = [
  {
    // Lunar New Year 2026 + 15-day celebration (through Lantern Festival)
    type: 'lunar-new-year',
    startMonth: 2,
    startDay: 17,
    endMonth: 3,
    endDay: 3,
    priority: 0
  },
  {
    // Ramadan 2026
    // Same priority as Lunar New Year — randomly alternated when both active
    type: 'ramadan',
    startMonth: 2,
    startDay: 17,
    endMonth: 3,
    endDay: 19,
    priority: 0
  },
  {
    type: 'halloween',
    startMonth: 10,
    startDay: 20,
    endMonth: 10,
    endDay: 31,
    priority: 0
  },
  {
    type: 'christmas',
    startMonth: 12,
    startDay: 20,
    endMonth: 12,
    endDay: 26,
    priority: 0
  },
  {
    type: 'winter',
    startMonth: 12,
    startDay: 1,
    endMonth: 2,
    endDay: 28,
    priority: 2
  },
  {
    type: 'default',
    startMonth: 1,
    startDay: 1,
    endMonth: 12,
    endDay: 31,
    priority: 999
  }
];
